<template>
    <div class="modal" :id="compModalIdentifier" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 900px;">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-center">
                        {{ isEdit ? 'Edit' : 'Create' }} Expense
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body bg-light" style="">
                    <fieldset>

                        <div class="row">
                            <div class="col-12">
                                <AdminBlock>
                                    <MovementSelect
                                        :movements="movements"
                                        :job="job"
                                        remove-margin
                                        required
                                        @update-movement="updateMovement"
                                    />
                                </AdminBlock>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-6">

                                    <AdminBlock
                                        title="Expense"
                                    >

                                        <InputTextField
                                            name="Label"
                                            label="label"
                                            placeholder="Label"
                                            required
                                            v-model="label"
                                        />

                                        <InputTextField
                                            name="reference"
                                            label="Reference (Optional)"
                                            placeholder="Reference"
                                            v-model="reference"
                                        />

                                        <InputNumberField
                                            name="fuel"
                                            label="Fuel (Optional)"
                                            placeholder="Fuel"
                                            append="Litres"
                                            v-model="fuel"
                                        />

                                        <div class="">
                                            <div class="mb-2">
                                                <label for="evidence_received">
                                                    <input
                                                        type="checkbox"
                                                        name="evidence_received"
                                                        id="evidence_received"
                                                        v-model="evidenceReceived"
                                                        class="me-2"
                                                    >
                                                    <strong>
                                                        Evidence Received (If assigned to Driver)
                                                    </strong>
                                                </label>
                                            </div>

                                            <div>
                                                <label for="recharge_client">
                                                    <input
                                                        type="checkbox"
                                                        name="recharge_client"
                                                        id="recharge_client"
                                                        v-model="rechargeClient"
                                                    >
                                                    <strong>
                                                        Recharge Client
                                                    </strong>
                                                </label>
                                            </div>
                                        </div>

                                    </AdminBlock>

                                    <AdminBlock
                                        title="Driver"
                                        class="mb-0"
                                    >

                                        <p>
                                            If the Expense was incurred by a Driver and needs paying back to them, please select them below.
                                        </p>

                                        <DriverSelect
                                            :driver="selectedDriver"
                                            removeMargin
                                            @update-driver="updateDriver"
                                        />

                                    </AdminBlock>

                            </div>

                            <div class="col-lg-6">
                                <AdminBlock
                                    title="Cost"
                                >
                                    <div class="mb-4">
                                        <label for="">
                                            <strong>
                                                Payment Method
                                            </strong>
                                        </label>

                                        <v-select
                                            :options="[
                                                'Cash',
                                                'Card',
                                                'By Admin'
                                            ]"
                                            placeholder="Payment Method"
                                            v-model="selectedPaymentMethod"
                                        />
                                    </div>

                                    <p>
                                        If you complete the Total and either the Price or VAT, the remaining field will be automatically filled.
                                    </p>

                                    <InputTextField
                                        name="price"
                                        label="Price (Optional)"
                                        placeholder="0.00"
                                        prepend="£"
                                        v-model="price"
                                    />

                                    <InputTextField
                                        name="vat"
                                        label="VAT Amount (Optional)"
                                        placeholder="0.00"
                                        prepend="£"
                                        v-model="vat"
                                    />

                                    <InputTextField
                                        name="total"
                                        label="Total (Optional if fuel)"
                                        placeholder="0.00"
                                        prepend="£"
                                        v-model="total"
                                        removeMargin
                                    />

                                </AdminBlock>

                                <AdminBlock
                                    title="Images"
                                    class="mb-0"
                                >

                                    <p class="mb-0">
                                        Please upload your receipts where possible
                                    </p>

                                    <FileUpload
                                        :file-upload-route="getFileUploadRoute()"
                                        no-margin
                                        multiple
                                        @file-uploaded="handleFileUploaded"
                                    />

                                </AdminBlock>
                            </div>
                        </div>
                    </fieldset>
                </div>

                <div class="modal-footer">
                    <button type="button"
                            :id="'create_' + getModalType() + 'contact_close_button'"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal">Close</button>

                    <button type="button" class="btn btn-primary" @click="createNewExpense" >
                        {{ isEdit ? 'Update' : 'Save' }}
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios';
import Modal from 'bootstrap/js/dist/modal';
import Swal from "sweetalert2";
import VSelect from 'vue-select';
import AdminBlock from '@/components/movements/components/AdminBlock.vue';
import DriverSelect from '@/components/movements/components/DriverSelect.vue';
import inputTextField from '@/components/movements/components/InputTextField.vue';
import InputNumberField from "@/components/movements/components/InputNumberField.vue";
import FileUpload from "@/components/movements/components/FileUpload.vue";
import MovementSelect from "@/components/movements/components/MovementSelect.vue";

export default {

        components: {
            MovementSelect,
            FileUpload,
            InputNumberField,
            AdminBlock,
            VSelect,
            inputTextField,
            DriverSelect,
        },

        props: {
            identifier: {
                type: String,
                default: '',
                required: false,
            },
            movements: {
                type: Array,
                default: () => [],
                required: false,
            },
            job: {
                type: Object,
                default: () => {},
                required: false,
            },
            expense: {
                type: Object,
                default: () => {},
                required: false,
            },
            isEdit: {
                type: Boolean,
                default: false,
                required: false,
            }
        },

        data() {
            return {

                label: '',
                reference: '',
                fuel: null,

                evidenceReceived: false,
                rechargeClient: false,

                selectedMovement: null,
                selectedDriver: null,
                selectedPaymentMethod: '',

                price: null,
                vat: null,
                total: null,

                modal: {},

                files: [],
                receiptFileSignature: [],
            }
        },

        methods: {

            getModalType () {
                return this.modalFor !== '' ? this.modalFor + '_' : ''
            },

            resetForm() {
                this.label = '';
                this.reference = '';
                this.fuel = null;

                this.evidenceReceived = false;
                this.rechargeClient = false;

                this.selectedDriver = null;
                this.selectedPaymentMethod = '';

                this.price = null;
                this.vat = null;
                this.total = null;

                this.receiptFileSignature = [];
            },

            createNewExpense () {

                const data = {
                    movement_id: this.selectedMovement?.id,
                    driver_id: this.selectedDriver?.id,
                    label: this.label,

                    payment_method: this.selectedPaymentMethod,

                    evidence_received: this.evidenceReceived,
                    recharge_client: this.rechargeClient,

                    reference: this.reference || null,
                    fuel: this.fuel || null,
                    price: this.price || null,
                    vat: this.vat || null,
                    total: this.total || null,

                    receipt_file_signature: this.receiptFileSignature || null,
                };

                const url = this.isEdit
                    ? route('api.movements.expenses.update', { expense: this.expense.id })
                    : route('api.movements.expenses.store');

                const method = this.isEdit ? 'put' : 'post';

                axios[method]( url, data, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                })
                    .then(response => {

                        this.$emit('expense-created', response.data);

                        Swal.fire({
                            toast: true,
                            position: 'top-end',
                            icon: 'success',
                            title: "Success!",
                            text: this.isEdit ? 'Expense Updated!' : 'Expense Created!',
                            timer: 3000,
                            timerProgressBar: true,
                            showConfirmButton: false,
                        });

                        this.resetForm();

                        window.jQuery('.modal-header .btn-close').click();

                    })
                    .catch( error => {

                        const errorMessages = error.response?.data?.errors || {};
                        const allErrors = Object.values(errorMessages)
                            .flat()
                            .map(msg => `<p class="mb-0">${msg}</p>`)
                            .join('');

                        Swal.fire({
                            toast: true,
                            position: 'top-end',
                            icon: 'error',
                            title: "Error Creating Expense",
                            html: allErrors || 'An error occurred',
                            timer: 3000,
                            showConfirmButton: false,
                        });

                    });

            },

            updateDriver ( value ) {
                this.selectedDriver = value;
            },

            updateMovement ( value ) {
                this.selectedMovement = value;
                this.selectedDriver = value ? value.driver : null;
            },

            handleFileUploaded (signatures) {
                this.receiptFileSignature = signatures;
            },

            getFileUploadRoute() {
                return route('api.movements.expenses.get-upload-url');
            },

        },

        mounted() {
            this.modal = new Modal(this.$el);
        },

        computed: {
            compModalIdentifier() {
                return this.identifier + '_expense_modal';
            },
        },

        watch: {
            expense(expense) {
                if (expense) {
                    this.label = expense.label;
                    this.reference = expense.reference;
                    this.fuel = expense.fuel;
                    this.evidenceReceived = expense.evidence_received;
                    this.rechargeClient = expense.recharge_client;
                    this.selectedMovement = expense.movement;
                    this.selectedDriver = expense.driver;
                    this.selectedPaymentMethod = expense.payment_method;
                    this.price = expense.price;
                    this.vat = expense.vat;
                    this.total = expense.total;
                }
            }
        },

    }

</script>
